export function toGID(id: string): string {
  return `gid://shopify/Product/${id}`
}

export function toNumericId(id: string, type: 'Product' | 'ProductVariant'): number {
  return Number(id.replace(`gid://shopify/${type}/`, ''))
}
